import script from "./UNoData.vue?vue&type=script&setup=true&lang=ts"
export * from "./UNoData.vue?vue&type=script&setup=true&lang=ts"

import "./UNoData.vue?vue&type=style&index=0&id=73978e60&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73978e60"]])

export default __exports__